import { OFFICE365_CLIENT_ID } from './constants';

/**
 * Builds the one-time Microsoft admin consent URL for Outlook/Office 365.
 * Tenant admins open this link to grant consent for their org; after that,
 * all users in that org can connect Outlook without seeing "Approval required".
 * Used for SaaS to make the experience seamless after one-time admin action.
 */
export function getOffice365AdminConsentUrl(): string {
  const redirectUri = `${typeof window !== 'undefined' ? window.location.origin : ''}/auth/office365/admin-consent-callback`;
  const params = new URLSearchParams({
    client_id: OFFICE365_CLIENT_ID,
    redirect_uri: redirectUri,
    state: 'admin_consent',
  });
  return `https://login.microsoftonline.com/common/adminconsent?${params.toString()}`;
}
